
import { useEffect } from 'react';
import { Page, SiteSettings } from '../types';

interface UsePageMetaProps {
    currentPage: Page;
    t: (key: string) => string;
    settings: SiteSettings | null;
}

export const usePageMeta = ({ currentPage, t, settings }: UsePageMetaProps): void => {
    useEffect(() => {
        let title = 'Squeaky Town';
        switch (currentPage) {
            case Page.HOME: title = 'SQUEAKY TOWN - Cửa hàng thú nhỏ'; break;
            case Page.SHOP: title = `${t('shop')} | Squeaky Town`; break;
            case Page.BLOG: title = `${t('blog')} | Squeaky Town`; break;
            case Page.ABOUT: title = `${t('about')} | Squeaky Town`; break;
            case Page.CONTACT: title = `${t('contact')} | Squeaky Town`; break;
            case Page.ADMIN_DASHBOARD: title = 'Admin | Squeaky Town'; break;
            case Page.ADMIN_LOGIN: title = 'Login | Squeaky Town'; break;
            case Page.SHIPPING_POLICY: title = 'Shipping Policy | Squeaky Town'; break;
            case Page.RETURN_POLICY: title = 'Returns Policy | Squeaky Town'; break;
        }
        
        if (currentPage !== Page.BLOG_POST) {
            document.title = title;
        }

        if (settings?.branding?.favicon_url) {
            const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
            if (link) link.href = settings.branding.favicon_url;
        }

        // Khôi phục lại og:image mặc định nếu không phải ở trang chi tiết bài viết
        if (currentPage !== Page.BLOG_POST) {
            const ogImage = document.querySelector('meta[property="og:image"]');
            if (ogImage) ogImage.setAttribute('content', 'https://squeakytown.store/og-image.png');
            const twitterImage = document.querySelector('meta[name="twitter:image"]');
            if (twitterImage) twitterImage.setAttribute('content', 'https://squeakytown.store/og-image.png');
        }
    }, [currentPage, t, settings]);
};
